import axios from 'axios'

export async function uploadDocumentToS3(s3Url: string, file: any) {
  const response = await axios({
    method: 'put',
    url: s3Url,
    data: file,
    headers: { 'Content-Type': file?.type },
  })

  return { results: response ?? [] }
}
